// Mock node-fetch for browser builds
// The SDK uses axios in browser environments, node-fetch should never be called
export default function fetch() {
  throw new Error('node-fetch should not be used in browser environment.');
}
export const Headers = class {};
export const Request = class {};
export const Response = class {};
